<template>
    <div class="modal fade" id="modal_details_income" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestPayment" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ i18n.t('layout.sidbar.incomes.details') }}
                    </h5>
                    <button @click="closeModal('modal_details_income', 'view')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body">

                    <div class="row mb-3">
                        <div class="col-md-12">
                            <h4 class="title-h4">
                                {{ i18n.t('views.clients.income.payment.info') }}
                            </h4>
                        </div>
                    </div>
                    <!-- information income (rocette) -->
                    <informations-income />
                    <!-- end information income (rocette) -->


                    <!-- bilan -->
                    <list-bilans v-if="hasPermission('view_member_bilans') && income?.service_type == 'bilan'"
                        :bilans="income?.bilans ?? []" :income="income" @saved="onIncomeUpdated"
                        @editBilan="emitEditBilan" />
                    <!-- end bilan -->
                    <!-- sessions -->
                    <list-bookings
                        v-if="hasPermission('view_member_session_bookings') && income?.service_type == 'coaching'"
                        :income="income" @saved="onIncomeUpdated" @editBooking="emitEditBooking" />
                    <!-- end sessions -->

                    <!-- payments -->
                    <div class="position-relative">
                        <hr>
                        <div class="row   mb-3">
                            <div class="col-md-12">
                                <h4 class="title-h4">
                                    {{ i18n.t('views.clients.income.payment.paid') }}
                                </h4>
                            </div>
                        </div>
                        <div v-if="incomesPaymentsList?.length > 0" class="tab-pane fade in active show"
                            id="income-payments" style="overflow-x: auto;">
                            <table class="datatables table table-striped table-bordered  ">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>
                                            {{ i18n.t('tables.payment.paymentDate') }}
                                        </th>

                                        <th>
                                            {{ i18n.t('tables.payment.paymentMethod') }}
                                        </th>
                                        <th>
                                            {{ i18n.t('tables.payment.chequeName') }}
                                        </th>
                                        <th>
                                            {{ i18n.t('tables.payment.bankName') }}
                                        </th>
                                        <th>
                                            {{ i18n.t('tables.payment.chequeNum') }}
                                        </th>
                                        <th>
                                            {{ i18n.t('tables.payment.dueDate') }}
                                        </th>
                                        <th>
                                            {{ i18n.t('tables.payment.amount_paid') }}
                                        </th>
                                        <th>
                                            {{ i18n.t('tables.action') }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(transaction) in incomesPaymentsList" value="member.id"
                                        v-bind:key="transaction?.id">
                                        <td>
                                            {{ formatDate(transaction?.paymentDate) }}
                                        </td>
                                        <td>
                                            {{ transaction.paymentMethod }}
                                        </td>
                                        <td>
                                            {{ transaction.chequeName }}
                                        </td>

                                        <td>
                                            {{ transaction?.bankName }}
                                        </td>

                                        <td>
                                            {{ transaction?.chequeNum }}
                                        </td>
                                        <td>
                                            {{ formatDate(transaction?.dueDate) }}
                                        </td>
                                        <td>
                                            {{ transaction?.amount_paid ?? 0.00 }} {{ i18n.t('symbole.currency.mad') }}
                                        </td>
                                        <td>
                                            <btn-delete @delete="Delete(transaction?.id)" />
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                        </div>
                        <div v-else>
                            <not-found :text="i18n.t('message.data_not_found.title')" icon="warning" />
                        </div>
                    </div>
                    <!-- end payments -->
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, computed, watch, ref } from "vue";
/*Components*/


/*plugins*/
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
/*composables & states */
import { useModal } from '@/composables/modal/useModal';
import { incomesPayments, transactions, bilans, singleIncome, sessionBookings, clubUUID } from "@/shared/state";
//import { IncomePayment } from "@/interfaces/income";
import { useGlobal } from "@/composables/global/useGlobal";
import { usePermission } from "@/composables/auth/usePermission";

import { usePayment } from "@/composables/payment/usePayment";
import { TransactionQueryParams } from "@/interfaces/payment";



export default defineComponent({
    components: {},
    name: "details-income",
    emits: ['saved', 'editBilan', 'editBooking', 'deletePayment'],
    props: {
        // income: {
        //     type: Object,
        //     default: null,
        // }
    },
    setup(props, { emit }) {
        //const { income } = toRefs(props);
        const { formatDate } = useGlobal();
        const { hasPermission } = usePermission();

        const { closeModal } = useModal();

        const { fetchTransactions, deletePayment, isRequestPayment } = usePayment();

        const incomesPaymentsList = computed(() => transactions.data);
        const income = computed(() => singleIncome.data);

        const searchBy = ref<TransactionQueryParams>({
            id: null,
            pack_id: null,
            subscription_id: null,
            is_renewal: null,
            clubUUID: clubUUID.value,
            memberUUID: null,
            memberName: "",
            memberCIN: "",
            memberTele: "",
            memberContract: "",
            paymentMethod: "",
            bankName: null,
            chequeName: null,
            chequeNum: null,
            dueDate: [],
            paymentDate: null,
            status: "paid",
            type: "all",
            page: null,
            limit: null,
            with_member: "false",
            summary: "true",
            reference_id: income?.value?.id ?? null,
            reference_type: "services"
        });
        const fetchTransactionsData = () => {
            searchBy.value.page = 1
            fetchTransactions(searchBy.value);
        };




        /**
       * Delete Income by ID
       */
        const Delete = (paymentID: number) => {
            if (income?.value) {
                Swal.fire({
                    title: i18n.t("message.confirmation.payment.delete.title"),
                    text: i18n.t("message.confirmation.payment.delete.text"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: i18n.t("button.delete"),
                    cancelButtonText: i18n.t("button.cancel"),
                    allowOutsideClick: false, // ✅ disable closing by clicking outside
                    allowEscapeKey: false, // (optional) disable closing with ESC
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        deletePayment(paymentID).then((res) => {
                           // fetchTransactionsData()
                            emit('deletePayment')

                        })
                    }
                });
            }
        };

        const onIncomeUpdated = () => {
            emit('saved');
        };
        const emitEditBilan = (bilan: any) => {
            emit('editBilan', bilan);
        };
        const emitEditBooking = (booking: any) => {
            emit('editBooking', booking);
        };


        watch(
            () => income.value,
            (newValue) => {
                if (income?.value) {
                    transactions.data = []
                    searchBy.value.reference_id = income?.value?.id ?? null
                    fetchTransactionsData()
                    bilans.data = income?.value?.bilans ?? []
                    sessionBookings.data = income?.value?.session_bookings ?? []
                }
            });

        return {
            singleIncome,
            income,
            emitEditBooking,
            emitEditBilan,
            onIncomeUpdated,
            bilans,
            incomesPaymentsList,
            formatDate,
            hasPermission,
            i18n,
            closeModal,
            Delete,
            isRequestPayment
        };
    },
});
</script>
